<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item>
                <el-upload
                    multiple
                    :with-credentials="true"
                    :show-file-list="false"
                    class="upload-demo"
                    :action="importPaperAnswerParam"
                    :on-success="uploadSuccess"
                   >
                    <el-button size="small" type="primary">上传钉钉日报信息<i class="el-icon-upload el-icon--right"></i></el-button>
                </el-upload>
                <el-button type="primary" @click="rebuildWeekPaperThankResult">重新生成感谢数据</el-button>
            </el-form-item>
            <el-form-item>
                <el-upload
                    multiple
                    :with-credentials="true"
                    :show-file-list="false"
                    class="upload-demo"
                    :action="importAaRrrDataParam"
                    :on-success="uploadSuccess"
                   >
                    <el-button size="small" type="primary">上传AARRR信息<i class="el-icon-upload el-icon--right"></i></el-button>
                </el-upload>
            </el-form-item>
        </el-form>

        <el-table :data="QuestionClassList" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="className" label="名称"></el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="handleEditClass(scope.row)">修改</el-button>
                    <el-button type="danger" size="mini" @click="handleEditTimeout(scope.row.classId,1)">填写时间</el-button>
                    <el-button type="danger" size="mini" @click="handleEditTimeout(scope.row.classId,2)">审核时间</el-button>
                    <el-button type="danger" size="mini" @click="handleEditTimeout(scope.row.classId,3)">异议时间</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
            <!-- class添加编辑 -->
            <el-dialog title="协作办公类型" :visible.sync="classFormVisible" center>
                <el-form :model="formClass" label-width="120px">
                    <el-form-item label="类型名称">
                        <el-input v-model="formClass.className" placeholder="类型名称"></el-input>
                    </el-form-item>
                    <el-form-item label="父类型">
                        <el-select v-model="formClass.parrentClassId"  placeholder="父类型">
                            <el-option v-for="item in questionClassData"
                                       :key="item.classId"
                                       :label="item.className"
                                       :value="item.classId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否投票">
                        <el-select v-model="formClass.enableVote" clearable  placeholder="是否投票">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色可见">
                        <el-select v-model="formClass.roleId"  placeholder="角色">
                            <el-option v-for="item in roleData"
                                       :key="item.roleId"
                                       :label="item.roleName"
                                       :value="item.roleId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="classFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editClass(formClass)">确 定</el-button>
                </div>
            </el-dialog>
            <!-- timeout添加编辑 -->
            <el-dialog title="时间配置" :visible.sync="timeoutFormVisible" center>
                <el-form :model="formTimeout" label-width="120px">
                    <el-form-item label="类型">
                        <el-select v-model="formTimeout.questionClassId" placeholder="类型" disabled>
                            <el-option v-for="item in questionClassData"
                                       :key="item.classId"
                                       :label="item.className"
                                       :value="item.classId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="操作类型">
                        <el-select v-model="formTimeout.questionClassSubType" clearable placeholder="操作类型" disabled>
                            <el-option label="填写" value="1"></el-option>
                            <el-option label="审核" value="2"></el-option>
                            <el-option label="异议" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开始时间延迟提交类型">
                        <el-select v-model="formTimeout.startTimeoutType" clearable placeholder="延迟提交类型">
                            <el-option label="开始时间延迟" value="1"></el-option>
                            <el-option label="结束时间延迟" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开始时间延迟小时数">
                        <el-input-number v-model="formTimeout.startTimeoutHours" placeholder="延迟小时数"></el-input-number>
                    </el-form-item>
                    <el-form-item label="结束时间延迟提交类型">
                        <el-select v-model="formTimeout.endTimeoutType" clearable placeholder="延迟提交类型">
                            <el-option label="开始时间延迟" value="1"></el-option>
                            <el-option label="结束时间延迟" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="结束时间延迟小时数">
                        <el-input-number v-model="formTimeout.endTimeoutHours" placeholder="延迟小时数"></el-input-number>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleUsers(formTimeout.id)">特例用户</el-button>
                    <el-button @click="timeoutFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editTimeout(formTimeout)">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 选用户 -->
            <el-dialog  title="组内用户" :visible.sync="dialogFormVisibleleaf" center :fullscreen="true">
                <div>
                    <template>
                        <el-transfer
                                filterable
                                :filter-method="filterMethod"
                                filter-placeholder="请输入邮箱"
                                v-model="chosedUsers"
                                :data="allUsers"
                                :titles="['全部用户', '组内用户']"
                                :props="{
                            key: 'USER_ID',
                            label: 'USER_NAME'
                        }">
                        </el-transfer>
                    </template>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisibleleaf = false">取 消</el-button>
                    <el-button type="primary" @click="updateOrAddLeaf">确 定</el-button>

                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {findQuestionClass,findRoleList,findQuestionClassList,saveQuestionClass,getQuesTimeout,saveQuestionClassTimeout,importAaRrrData,importPaperAnswer} from '@/api/api';
    import {getCooperativeAllUserList, getTimeoutSpecialUsers, saveTimeoutSpecialUsers,rebuildWeekPaperThankResult} from "../../api/api";
    export default {
        data() {
            return {
                questionClassData: [],
                roleData: [],
                QuestionClassList: [],
                allUsers: [],
                chosedUsers: [],
                classFormVisible : false,
                timeoutFormVisible : false,
                dialogFormVisibleleaf : false,
                loading: true,
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                formClass:{
                    classId : "",
                    className : "",
                    parrentClassId : "",
                    enableVote : "",
                    roleId : ""
                },
                formTimeout:{
                    id : "",
                    questionClassId : "",
                    questionClassSubType : "",
                    startTimeoutType : "",
                    startTimeoutHours : 0,
                    endTimeoutType : "",
                    endTimeoutHours : 0
                },
                importPaperAnswerParam:importPaperAnswer,
                importAaRrrDataParam:importAaRrrData
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.findList();
            this.findRoleList();
            this.findQuestionClassList();
        },
        methods: {
            uploadSuccess(res){
                if(res.status==500){
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'error'
                    });
                }
                if(res.status==400){
                    this.$message({
                        showClose: true,
                        message: "请上传excel文件",
                        type: 'error'
                    });
                }
                if(res.status==200){
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'success'
                    });
                }
            },

            findRoleList(){
                findRoleList().then((res) => {
                    if (res.data.status == 200) {
                        this.roleData = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            findQuestionClassList(){
                findQuestionClassList().then((res) => {
                    if (res.data.status == 200) {
                        this.questionClassData = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            findList(){
                findQuestionClass(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.QuestionClassList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleEditClass(row){
                this.formClass.classId = row.classId;
                this.formClass.className = row.className;
                this.formClass.parrentClassId = row.parrentClassId;
                this.formClass.enableVote = "" + row.enableVote;
                this.formClass.roleId = row.roleId;
                this.classFormVisible = true;
            },
            editClass(form){
                // if(this.pageConfig.parrentClassId==''){
                //     this.$message({
                //         showClose: true,
                //         message: 'url必填',
                //         type: 'error'
                //     });
                //     return;
                // }
                this.loading = true;
                saveQuestionClass(this.formClass).then((res) => {
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.classFormVisible = false;
                });
            },
            handleEditTimeout(classId,subType){
                this.timeoutFormVisible = true;

                getQuesTimeout({'classId':classId,'subType':subType}).then((res) => {
                    this.loading = false;
                    if (res.data.success) {
                        this.formTimeout.id = res.data.value.id;
                        this.formTimeout.questionClassId = res.data.value.questionClassId;
                        this.formTimeout.questionClassSubType = "" + res.data.value.questionClassSubType;
                        this.formTimeout.startTimeoutType = "" + res.data.value.startTimeoutType;
                        this.formTimeout.startTimeoutHours = res.data.value.startTimeoutHours;
                        this.formTimeout.endTimeoutType = "" + res.data.value.endTimeoutType;
                        this.formTimeout.endTimeoutHours = res.data.value.endTimeoutHours;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.classFormVisible = false;
                });

            },
            editTimeout(form){
                // if(this.pageConfig.parrentClassId==''){
                //     this.$message({
                //         showClose: true,
                //         message: 'url必填',
                //         type: 'error'
                //     });
                //     return;
                // }
                this.loading = true;
                saveQuestionClassTimeout(this.formTimeout).then((res) => {
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.timeoutFormVisible = false;
                });
            },
            handleUsers(timeoutId) {
                this.dialogFormVisibleleaf = true;
                this.allUsers = [];
                this.chosedUsers = [];
                this.getLeafList(timeoutId);
            },
            getLeafList(timeoutId) {
                //未选用户列表
                getCooperativeAllUserList().then((res) => {
                    if(res.data.status == 200){
                        this.allUsers = res.data.value;
                        //已选用户列表
                        getTimeoutSpecialUsers({"timeoutId":timeoutId}).then((res1) => {
                            if (res1.data.status == 200) {
                                console.log("=====",this.allUsers);
                                console.log("=====",res1.data.value);
                                for(var i = 0 ; i < res1.data.value.length; i++){
                                    this.chosedUsers.push(res1.data.value[i].userId);
                                }
                                // for(var i = 0 ; i < res1.data.value.length; i++){
                                //     for(var j = 0; j < this.allUsers.length; j++){
                                //         if(this.allUsers[j].USER_ID == res1.data.value[i].userId){
                                //             this.chosedUsers.push(this.allUsers[j].USER_ID);
                                //             break;
                                //         }
                                //     }
                                // }
                                console.log("=====",this.allUsers);
                                console.log("=====",this.chosedUsers);
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res1.data.message,
                                    type: 'error'
                                });
                            }
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            updateOrAddLeaf() {
                var userIdStr = "";
                for(var i = 0; i < this.chosedUsers.length; i++){
                    userIdStr = userIdStr + this.chosedUsers[i] + ",";
                }
                saveTimeoutSpecialUsers({"timeoutId":this.formTimeout.id,"userIds":userIdStr}).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            rebuildWeekPaperThankResult(){
                rebuildWeekPaperThankResult().then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            filterMethod(query, item) {
                return item.USER_NAME.indexOf(query) > -1;
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.findList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.findList();
            }
        }
    }
</script>
<style>
    .el-transfer{
        margin-left: 20%;
        height: 600px;
    }
    .el-transfer-panel{
        width:30%;
        height: 600px;
    }
    .el-transfer-panel__list.is-filterable{
        height: 584px;
    }
</style>


// WEBPACK FOOTER //
// src/views/cooperative-manage/QuestionClasses.vue